import { makeStyles } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  title: {
    fontSize: 14,
    color: blue.A100,
    textTransform: "uppercase",
    fontWeight: 600,
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
  },
}));
